var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20C0 31 9 40 20 40C31 40 40 31 40 20C40 9 31 0 20 0ZM12.86 24.88L10.14 23.66C10.7 22.54 11 21.34 11 20.1C11 18.78 10.7 17.52 10.14 16.34L12.86 15.12C13.62 16.74 14 18.4 14 20.1C14 21.6 13.62 23.2 12.86 24.88ZM19.06 27.88L16.44 26.58C17.5 24.32 18 22 18 19.72C18 17.46 17.5 15.38 16.44 13.42L19.06 11.92C20.38 14.24 21 16.84 21 19.72C21 22.66 20.38 25.38 19.06 27.88ZM25.36 30.7L22.62 29.3C24.2 26.22 25 23.14 25 20C25 16.86 24.2 13.74 22.62 10.62L25.36 9.3C27.1 12.86 28 16.44 28 20C28 23.64 27.1 27.2 25.36 30.7Z",
    fill: "url(#paint0_linear_125_643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_643",
    x1: -6.09215e-8,
    y1: 20.2108,
    x2: 41.8202,
    y2: 20.2051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00394562,
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpay);
export default __webpack_public_path__ + "static/media/spay.d59491b44658fbb6e2f23309497463c7.svg";
export { ForwardRef as ReactComponent };